// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1dggp","amount":"Amount_amount__3PG5C","tip":"Amount_tip__2_z3k","tipHeader":"Amount_tipHeader__1YfLr","tipsWrap":"Amount_tipsWrap__150ve"};